import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { Point } from '../../core';
import { Stage } from '../model';
import { Room } from '../item';

export default class ItemControllerRoomWallEdit {
  x: number;

  y: number;

  type: string;

  roomList: marietta.webcad.item.Room[] = [];

  wallList: marietta.webcad.item.parts.Wall[] = [];

  isInitDone: boolean = false;

  targetWalls: marietta.webcad.item.parts.Wall[];

  mode: string;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorLayer;

  transformMatrix: string;

  moveMouseEvent: MouseEvent;

  public spt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_mode: string) {
    console.log('edit wall');
    this.mode = _mode;

    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor);

    // お部屋リストの取得
    this.roomList = this.tarLayer.layer_room.getAllChildren() as Room[];
    this.roomList = this.roomList.concat(this.tarLayer.layer_roomdown1.getAllChildren() as Room[], this.tarLayer.layer_roomdown2.getAllChildren() as Room[]);

    for (let i: number = 0; i < this.roomList.length; i += 1) {
      if (!this.roomList[i].itemInfo.lock) {
        this.wallList = this.wallList.concat((this.roomList[i] as marietta.webcad.item.Room).wallObjList);
      }
    }
    // 階段も対象
    const isTargetInclueStairsMode = () => (this.mode !== 'addPoint' && this.mode !== 'calibrationWall');
    if (isTargetInclueStairsMode()) {
      const stairList = this.tarLayer.layer_stair.getAllChildren();
      for (let i = 0; i < stairList.length; i += 1) {
        this.wallList = this.wallList.concat((stairList[i] as marietta.webcad.item.Stair).wallObjList);
      }
    }

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    const shitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    if (ua.isMobile || ua.isTablet) {
      // タップ用のダミーオブジェクトの生成
      this.createDummyObj(this.tarLayer);
      // document.addEventListener("touchmove", this.followMouse , { passive: false });
      document.addEventListener('touchstart', this.onMouseDown, { passive: false });
    } else {
      // ペンの作成
      this.createPen(shitaeLayer);

      document.addEventListener('mousemove', this.followMouse);
      document.addEventListener('mousedown', this.onMouseDown);
    }
    const scope: ItemControllerRoomWallEdit = this;

    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.moveDragHandler();
      }
    };
    ua = null;
  }

  /**
   * 複数選択を許すかどうか
   * @returns
   */
  private permitMultipleSelection(): boolean {
    return this.mode !== 'calibrationWall';
  }

  private moveDragHandler(): void {
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    this.spt.x = newPoint.x;
    this.spt.y = newPoint.y;
    this.spt.update();

    // ターゲットの壁
    let targetWall: marietta.webcad.item.parts.Wall;
    this.targetWalls = this.getClosestWalls();
    if (this.targetWalls.length < 1) return;
    if (!this.permitMultipleSelection()) { // 単体選択のみ
      this.targetWalls = [this.targetWalls[0]];
    }

    for (let i: number = 0; i < this.targetWalls.length; i += 1) {
      targetWall = this.targetWalls[i] as marietta.webcad.item.parts.Wall;
      targetWall.highlight(true);
    }
  }

  /**
   * ペンの生成
   * @param FloorShitaeLayer
   */
  createPen(tarLayer: marietta.webcad.layer.FloorShitaeLayer) {
    // ペンの生成
    const targetItem = '#lib_icon_pen_addPoint';// + this.mode;
    const viewObj: SVGElement = (<SVGElement>document.querySelector(targetItem).querySelector('svg > g').cloneNode(true));
    viewObj.setAttribute('id', 'controller');
    tarLayer.viewObj.appendChild(viewObj);

    this.spt = new SVGSprite(viewObj);

    // お掃除
    viewObj.addEventListener('onabort', this.cleanUp);
    (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
  }

  /**
   * タップ用のダミーオブジェクト生成
   * @param FloorLayer
   */
  createDummyObj(tarLayer: marietta.webcad.layer.FloorLayer) {
    const rect: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('width', String(marietta.webcad.WebCADGlobal.LAYER_SIZE_W));
    rect.setAttribute('height', String(marietta.webcad.WebCADGlobal.LAYER_SIZE_H));
    rect.setAttribute('x', '0');
    rect.setAttribute('y', '0');
    rect.style.opacity = '0';
    rect.setAttribute('id', 'controller');
    tarLayer.viewObj.appendChild(rect);

    this.spt = new SVGSprite(rect);
    // お掃除
    // viewObj.addEventListener("onabort", this.cleanUp  );
  }

  /**
   * お掃除
   */
  cleanUp = () => {
  }

  /**
   * マウス追従
   */
  followMouse = (e: MouseEvent) => {
    e.preventDefault();
    this.moveMouseEvent = e;
  }

  /**
   * 一番近い壁を探す
   * @return Wall
   */
  getClosestWalls(): marietta.webcad.item.parts.Wall[] {
    const newPoint: any = this.tarLayer.spt.localToGlobal(new Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY));

    // 近い壁を探す（距離が近い順に並べる。単体選択モードでは先頭＝最も近い壁を使うため）
    const candidates: { wall: marietta.webcad.item.parts.Wall; distance: number }[] = [];
    let crossPoint: any;
    let distance: number;
    for (let i: number = 0; i < this.wallList.length; i += 1) {
      (this.wallList[i] as marietta.webcad.item.parts.Wall).highlight(false);
      crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint((this.wallList[i] as marietta.webcad.item.parts.Wall).startDotGlobalPoint, (this.wallList[i] as marietta.webcad.item.parts.Wall).endDotGlobalPoint, newPoint);
      if (crossPoint != null) {
        distance = marietta.core.Point.distance(crossPoint, newPoint);
        if (distance <= 20) {
          candidates.push({ wall: this.wallList[i] as marietta.webcad.item.parts.Wall, distance });
        }
      }
    }
    candidates.sort((a, b) => a.distance - b.distance);
    return candidates.map((candidate) => candidate.wall);
  }

  /**
   * マウス追従終了
   */
  stopFollowMouse = () => {
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.removeEventListener('touchmove', this.followMouse);
      document.removeEventListener('touchstart', this.onMouseDown);
    } else {
      document.removeEventListener('mousemove', this.followMouse);
      document.removeEventListener('mousedown', this.onMouseDown);
    }
    this.spt.deleteEnterFrame();
    this.moveMouseEvent = null;
    ua = null;

    (<HTMLElement>document.querySelector('.addPointGuide')).style.display = 'none';
    (<HTMLElement>document.querySelector('.addWallGuide')).style.display = 'none';
    (<HTMLElement>document.querySelector('.deleteWallGuide')).style.display = 'none';
    (<HTMLElement>document.querySelector('.calibrationWallGuide')).style.display = 'none';

    // ペンの削除
    document.querySelector('#controller')?.remove();
  }

  /**
   * ドットの作成
   * @param MouseEvent
   */
  onMouseDown = (e: MouseEvent) => {
    console.log('make dot');
    (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
    // pad,スマホにfollowMouseが効かないので、ここでターゲットの取得を行う
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // pad スマホ用タッチ座標修正
      Stage.refreshStageMouse(<any>e);

      const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
      this.spt.x = newPoint.x;
      this.spt.y = newPoint.y;
      this.spt.update();

      // ターゲットの壁
      let targetWall: marietta.webcad.item.parts.Wall;
      this.targetWalls = this.getClosestWalls();
      if (this.targetWalls.length < 1) {
        this.stopFollowMouse();
        return;
      }

      for (let i: number = 0; i < this.targetWalls.length; i += 1) {
        targetWall = this.targetWalls[i] as marietta.webcad.item.parts.Wall;
        targetWall.highlight(true);
      }
    }

    // マウス吸着停止

    this.stopFollowMouse();

    if (this.targetWalls === null || this.targetWalls === undefined) return;
    if (this.targetWalls.length < 1) return;

    let k: number;
    let i: number;
    let targetWall: marietta.webcad.item.parts.Wall;
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    let localPoint: marietta.core.Point;
    let preSnapPoint: marietta.core.Point;
    let crossPoint: marietta.core.Point;
    let newDot: marietta.webcad.collection.PointCollection;
    let newList: marietta.webcad.collection.PointCollection[];
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    switch (this.mode) {
      case 'addPoint':
        for (k = 0; k < this.targetWalls.length; k += 1) {
          targetWall = this.targetWalls[k] as marietta.webcad.item.parts.Wall;

          // 頂点の追加
          localPoint = new marietta.core.Point(newPoint.x, newPoint.y);
          localPoint.x -= targetWall.parentObj.itemInfo.x;
          localPoint.y -= targetWall.parentObj.itemInfo.y;

          // 水平、垂直の場合は、座標を揃えておく
          if (Math.max(localPoint.x, targetWall.startDot.x) - Math.min(localPoint.x, targetWall.startDot.x) < 10) localPoint.x = targetWall.startDot.x;
          if (Math.max(localPoint.x, targetWall.endDot.x) - Math.min(localPoint.x, targetWall.endDot.x) < 10) localPoint.x = targetWall.endDot.x;
          if (Math.max(localPoint.y, targetWall.startDot.y) - Math.min(localPoint.y, targetWall.startDot.y) < 10) localPoint.y = targetWall.startDot.y;
          if (Math.max(localPoint.y, targetWall.endDot.y) - Math.min(localPoint.y, targetWall.endDot.y) < 10) localPoint.y = targetWall.endDot.y;

          // 吸着（戸建てのみ。マンションはスナップ無効のため丸めない）
          preSnapPoint = new marietta.core.Point(localPoint.x, localPoint.y);
          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap()) {
            localPoint.x = Math.round(localPoint.x / snapUnit) * snapUnit;
            localPoint.y = Math.round(localPoint.y / snapUnit) * snapUnit;
          }

          // 追加する頂点は必ず辺の直線上に乗せる（辺への垂直投影）
          crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint(targetWall.startDot.point, targetWall.endDot.point, localPoint);
          if (crossPoint === null) {
            // 吸着で線分の外に出た場合は、吸着前の位置で投影し直す
            crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint(targetWall.startDot.point, targetWall.endDot.point, preSnapPoint);
          }
          if (crossPoint !== null) {
            localPoint.x = crossPoint.x;
            localPoint.y = crossPoint.y;
          }

          newDot = new marietta.webcad.collection.PointCollection();
          newDot.x = localPoint.x;
          newDot.y = localPoint.y;
          newDot.wall_type = targetWall.wallType;
          newDot.guid = marietta.webcad.WebCADGlobal.getGuid();

          newList = [];
          for (i = 0; i < targetWall.parentObj.itemInfo.dotList.length; i += 1) {
            newList.push(targetWall.parentObj.itemInfo.dotList[i]);
            if (targetWall.index === i) {
              newList.push(newDot);
            }
          }
          targetWall.parentObj.itemInfo.dotList = newList;
          targetWall.parentObj.reCreateImage();
        }

        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

        break;
      case 'removeWall':
        for (k = 0; k < this.targetWalls.length; k += 1) {
          targetWall = this.targetWalls[k] as marietta.webcad.item.parts.Wall;
          targetWall.removeWall();
        }

        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

        break;
      case 'addWall':
        for (k = 0; k < this.targetWalls.length; k += 1) {
          targetWall = this.targetWalls[k] as marietta.webcad.item.parts.Wall;
          targetWall.addWall();
        }

        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

        break;
      case 'calibrationWall':
        targetWall = this.targetWalls[0]; // 単体選択のみ許可 permitMultipluSelection関数で管理
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CalibrationDialog, false, true, false, true, {targetWall: targetWall});
        break;
      default: break;
    }
    //見積リスト更新
    marietta.webcad.WebCADGlobal.quotationItemList.createData(true);

    marietta.webcad.WebCADGlobal.itemManager.currentItem = targetWall.parentObj;
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.update();
  }

  /**
   * アイテムの削除
   */
  deleteMe() {
    this.stopFollowMouse();
  }
}
